import React, { useState, useEffect, useContext } from "react";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Button, Card, CardContent, Divider } from "@material-ui/core";

import ForumOutlinedIcon from "@material-ui/icons/ForumOutlined";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import ClearIcon from "@material-ui/icons/Clear";
import DoneIcon from "@material-ui/icons/Done";

import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useSnackbar } from "notistack";

import { verificarFormularioVinculado} from "../../../../../services/reuniao/ReuniaoService";
import {
  respostas,
  respostasPorAreaDeAtuacao,
  salvarRespostas,
} from "../../../../../services/preenchimentoFormulario/PreenchimentoFormularioService";
import { AppContext } from "../../../../shared/context";

import UseStyle from "../../../useStyles";

import FormularioStatus from "../../../formularioSumula/formularioStatus";
import moment from "moment";
import AccordionRespostas from "../../../accordionRespostas";

const AbaFormulario = (props) => {
  const { roleSelecionada, roles, role } = useContext(AppContext);
  const [formularioRespostas, setFormularioRespostas] = useState([]);
  const [formulariosRespostas, setFormulariosRespostas] = useState([]);
  const [isPrazoResponder, setIsPrazoResponder] = useState(false)

  const { dados, updateDados } = props;
  const classes = UseStyle();

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (dados.id) verificarExistenciaFormularioVinculado(dados.id);
  }, []);

  const verificarExistenciaFormularioVinculado = (idReuniao) => {
    verificarFormularioVinculado(idReuniao).then((response) => {
      if (
        response &&
        response.status === 200 &&
        Object.keys(response.data).length > 0
      ) {
        const data = response.data;
        let dadosFormulario = {
          id: data.id,
          nome: data.nomeFormulario,
          status: data.status,
          dataInicio: data.dataInicio,
          dataLimite: data.dataLimite,
        };

        updateDados((prevDados) => ({
          ...prevDados,
          formulario: {
            ...prevDados.formulario,
            ...dadosFormulario,
          },
        }));
      } else if (response && response.status === 404) {
        updateDados((prevDados) => ({
          ...prevDados,
          formulario: {
            id: null,
            nome: null,
            status: null,
            dataInicio: null,
            dataLimite: null,
            preenchimentos: [],
          },
        }));
        enqueueSnackbar("Nenhum Formulário vinculado nesta reunião", {
          variant: "warning",
        });
      } else {
        enqueueSnackbar(
          "Ocorreu um erro ao recuperar se há Formulário vinculado",
          {
            variant: "error",
          }
        );
      }
    });
  };

  useEffect(() => {
    if (dados.formulario?.status == "DISPONIBILIZADO"){
      if(roleSelecionada?.id == 1){ // Nacional
        getRespostas(
          dados?.id,
          setFormulariosRespostas
        );
      } else {
        getRespostasPorAreaDeAtuacao(
          dados?.id,
          roleSelecionada?.id,
          setFormularioRespostas
        );
      }
    }

  }, [dados.formulario]);

  const getRespostas = (
    idReuniao,
    formulariosRespostas
  ) => {
    respostas(idReuniao).then(
      (response) => {
        if (
          response &&
          response.status === 200 &&
          Object.keys(response.data).length > 0
        ) {
          formulariosRespostas(response.data);
          setIsPrazoResponder(moment().format("DD-MM-YYYY") <= moment(dados.formulario?.dataLimite, "YYYY-MM-DDThh:mm:ss").format("DD-MM-YYYY"))
        } else if (moment().format("DD-MM-YYYY") <= moment(dados.formulario?.dataInicio, "YYYY-MM-DDThh:mm:ss").format("DD-MM-YYYY")) {
          enqueueSnackbar(
            "Não há respostas preenchidas, pois o formulário ainda não estar disponibilizado",
            {
              variant: "warning",
            }
          );
        }
        else {
          enqueueSnackbar(
            "Erro ao buscar as respostas ao formulário disponibilizado",
            {
              variant: "error",
            }
          );
          formulariosRespostas([]);
        }
      }
    );
  }

  const getRespostasPorAreaDeAtuacao = (
    idReuniao,
    userAtuacaoRoleSelecionada,
    formularioRespostas
  ) => {
    respostasPorAreaDeAtuacao(idReuniao, userAtuacaoRoleSelecionada).then(
      (response) => {
        if (
          response &&
          response.status === 200 &&
          Object.keys(response.data).length > 0
        ) {
          formularioRespostas(response.data.respostas);
          setIsPrazoResponder(moment().format("DD-MM-YYYY") <= moment(dados.formulario?.dataLimite, "YYYY-MM-DDThh:mm:ss").format("DD-MM-YYYY"))
        } else if (moment().format("DD-MM-YYYY") <= moment(dados.formulario?.dataInicio, "YYYY-MM-DDThh:mm:ss").format("DD-MM-YYYY")) {
          enqueueSnackbar(
            "Não há respostas, pois o formulário ainda não estar disponibilizado",
            {
              variant: "warning",
            }
          );
        }
        else {
          enqueueSnackbar(
            "Erro ao buscar as respostas ao formulário disponibilizado",
            {
              variant: "error",
            }
          );
          formularioRespostas([]);
        }
      }
    );
  };
  const updateRespostaData = (
    formularioRespostas,
    setFormularioRespostas,
    id,
    newData
  ) => {
    let newFormularioRespostas = formularioRespostas;

    for (let i = 0; i < newFormularioRespostas.length; i++) {
      if (newFormularioRespostas[i].id === id) {
        newFormularioRespostas[i].resposta = newData;
        break;
      }
    }
    setFormularioRespostas(newFormularioRespostas);
  };

  const descartarAlteracoesFormulario = (dadosId, roleSelecionadaId, setFormularioRespostas) => {    
    getRespostasPorAreaDeAtuacao(
      dadosId,
      roleSelecionadaId,
      setFormularioRespostas
    );
  };

  const salvarRespostaFormulario = (idReuniao, idAtuacao, respostas) => {
    const respostasAjustadas = { respostas: respostas };
    salvarRespostas(idReuniao, idAtuacao, respostasAjustadas).then(
      (response) => {
        if (
          response &&
          response.status === 200 &&
          Object.keys(response.data).length > 0
        ) {
          const data = response.data;

          getRespostasPorAreaDeAtuacao(
            dados?.id,
            roleSelecionada?.id,
            setFormularioRespostas
          );
          enqueueSnackbar(
            "Respostas salvas com sucesso!",
            {
              variant: "success",
            }
          );
        } else {
          enqueueSnackbar(
            "Ocorreu um erro ao salvar as respostas para o Formulário vinculado nesta reunião",
            {
              variant: "error",
            }
          );
        }
      }
    );
  };

  return (
    <>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <Typography className={classes.tituloAba}>
                Formulário para reunião
              </Typography>
            </div>
            <div>
              {dados.formulario && (
                <FormularioStatus
                  nome={dados.formulario?.nome}
                  dataInicio={dados.formulario?.dataInicio}
                  dataLimite={dados.formulario?.dataLimite}
                />
              )}
            </div>
          </>

          {formularioRespostas?.length > 0 && (
            <>
              <Divider style={{ marginTop: 30, marginBottom: 5 }} />

              <Typography style={{ fontWeight: "bolder" }}>
                Perguntas deste Formulário:
              </Typography>

              {formularioRespostas.map((item, key) => (
                <Grid
                  key={item.id}
                  style={{
                    width: "100%",
                    padding: 0,
                    marginTop: 30,
                    padding: 0,
                  }}
                >
                  <Grid
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      marginBottom: "10px",
                      gap: "5px"
                    }}
                  >
                    <Typography
                      style={{ fontWeight: "bolder" }}
                      component="div"
                    >
                      Pergunta {key+1}:
                    </Typography>
                    {item.nomeCampoFormulario}

                    
                  </Grid>
                  <Grid
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: "6px",
                    }}
                  >
                    {
                    !!role.includes("ROLE_EQUIPE_TECNICA_") ? (
                      <Card>
                        {formularioRespostas[key].resposta ? (
                          <CardContent dangerouslySetInnerHTML={{
                            __html: formularioRespostas[key].resposta,
                          }}/>
                        ): 
                          <CardContent>
                            Sem resposta cadastrada
                          </CardContent>
                        }
                      </Card>
                    ) : 
                    isPrazoResponder ? 
                    (
                      <CKEditor
                        style={{
                          height: "200px",
                          marginTop: "10px",
                          fontStyle: "normal",
                        }}
                        config={{
                          toolbar: [
                            "bold",
                            "italic",
                            "heading",
                            "bulletedList",
                            "numberedList",
                            "blockQuote",
                            "link",
                          ],
                          heading: {
                            options: [
                              {
                                model: "paragraph",
                                title: "Normal",
                                class: "ck-heading_paragraph",
                              },
                              {
                                model: "heading1",
                                view: "h1",
                                title: "Heading 1",
                                class: "ck-heading_heading1",
                              },
                              {
                                model: "heading2",
                                view: "h2",
                                title: "Heading 2",
                                class: "ck-heading_heading2",
                              },
                            ],
                          },
                        }}
                        // item.resposta
                        // formularioRespostas[key].resposta
                        data={formularioRespostas[key].resposta}
                        // {resposta.resposta ?? ""}
                        editor={ClassicEditor}
                        onInit={() => {}}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          updateRespostaData(
                            formularioRespostas,
                            setFormularioRespostas,
                            item.id,
                            data
                          );
                        }}
                      />
                    )
                    :(
                      <Card>
                        {formularioRespostas[key].resposta ? (
                          <CardContent dangerouslySetInnerHTML={{
                            __html: formularioRespostas[key].resposta,
                          }}/>
                        ): 
                          <CardContent>
                            Sem resposta cadastrada no tempo em que o formulario foi disponibilizado
                          </CardContent>
                        }
                      </Card>
                    )
                      
                  }
                  </Grid>
                </Grid>
              ))}
              <Grid
                style={{
                  marginTop: 30,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  gap: 10,
                }}
              >
                {!!!role.includes("ROLE_EQUIPE_TECNICA_")
                && isPrazoResponder
                && (
                  <>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        descartarAlteracoesFormulario(dados?.id,
                          roleSelecionada?.id,
                          setFormularioRespostas)
                      }}
                    >
                      <ClearIcon />
                      Descartar alterações
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => {
                        salvarRespostaFormulario(
                          dados.id,
                          roleSelecionada?.id,
                          formularioRespostas
                        );
                      }}
                    >
                      <DoneIcon />
                      Salvar respostas
                    </Button>
                  </>
                )}
              </Grid>
            </>
          )}

          {formulariosRespostas?.length > 0 &&
          (
            <AccordionRespostas
              respostas={formulariosRespostas}
              exibirComentarios={false}
              exibirAcoes={false}
              exibirSelect={false}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default AbaFormulario;
